<div class="invoice-list" *ngIf="commission && commission.success && !calculateLoading">

	<!--Amount-->
	<div class="table-row">

		<span>
			<ng-container *ngIf="payAmountTitle !== undefined">
				{{payAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="payAmountTitle === undefined">
				{{'REQUEST.COMMISSION.PAY_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span class="text-color-grey-500 amount">
			<span class="number">
				{{ commission.requestedAmount | tcCurrency: commission.requestedPrecision }}
			</span>

			<span class="currency">{{commission.requestedCurrencyCode}}</span>

		</span>

	</div>

	<!--Exchange Rate-->
	<div class="table-row">
		<span>
			{{'REQUEST.COMMISSION.EXCHANGE_RATE' | translate}}
		</span>

		<span class="amount">
			<span class="number">
				{{ commission.exchangeRate | tcCurrency: 10 }}
			</span>
			<span class="currency">
				<ng-container *ngIf="commission.exchangeRate !== 1">
					{{commission.exchangeCurrencyCode}}
				</ng-container>
			</span>
		</span>
	</div>

	<!--CONVERSION AMOUNT-->
	<div class="table-row">
		<span>
			{{'REQUEST.COMMISSION.CONVERTED_AMOUNT' | translate}}
		</span>
		<span class="amount">
			<span class="number">
				{{commission.convertedAmount | tcCurrency: commission.payOrGetPrecision }}
			</span>
			<span class="currency">
				{{commission.payOrGetCurrencyCode}}
			</span>
		</span>
	</div>

	<ng-container *ngIf="commission.commissionType !== commissionType.NONE">

		<!--Commission-->
		<div class="table-row" *ngIf="commission.commissionInitialFee > 0">
			<span>
				<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
					{{'REQUEST.COMMISSION.INITIAL_COST' | translate}}
				</ng-container>

				<ng-container *ngIf="commission.commissionType === commissionType.BONUS">
					{{'REQUEST.COMMISSION.BONUS_FIXED_AMOUNT' | translate}}
				</ng-container>
			</span>

			<span class="amount">
				<span class="number">
					{{commission.commissionInitialFee | tcCurrency: commission.payOrGetPrecision}}
				</span>
				<span class="currency">
					<ng-container >
						{{ commission.payOrGetCurrencyCode }}
					</ng-container>
				</span>
			</span>
		</div>

		<div class="commission">

			<div class="table-row">
				<span>
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.COMMISSION' | translate}}
					</ng-container>

					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.BONUS' | translate}}
					</ng-container>

					<ng-container *ngIf="commission.commissionPercent != 0">{{commission.commissionPercent}}%
					</ng-container>

				</span>

				<span class="commition-amount amount">
					<span class="number">
						{{ commission.commissionAmount | tcCurrency: commission.payOrGetPrecision }}
					</span>


					<span class="currency" *ngIf="commission.commissionAmount > 0">
						{{ commission.payOrGetCurrencyCode }}
					</span>
				</span>
			</div>

			<span class="data"
				*ngIf="(commission.minCommission > 0 || commission.maxCommission > 0) &&
                 commission.commissionAmount > 0 && (commission.commissionCalcType && commission.commissionCalcType !== commissionCalcType.CALCULATED)">

				<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MINIMUM">
					<!--title-->
					<ng-container *ngIf="commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.MINIMUM_COMMISION' | translate}}</ng-container>
					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.MINIMUM_BONUS' | translate}}</ng-container>
					<!--amount-->
					<span class="amount">
						<span class="number">
							{{commission.minCommission | tcCurrency: commission.payOrGetPrecision }}
						</span>
						<span class="currency">
							{{commission.payOrGetCurrencyCode}}
						</span>
					</span>
				</span>

				<span class="red" *ngIf="commission.commissionCalcType === commissionCalcType.MAXIMUM">
					<!--title-->
					<ng-container *ngIf=" commission.commissionType === commissionType.COMMISSION">
						{{'REQUEST.COMMISSION.MAXIMUM_COMMISION' | translate}}</ng-container>
					<ng-container *ngIf=" commission.commissionType === commissionType.BONUS">
						{{'REQUEST.COMMISSION.MAXIMUM_BONUS' | translate}}</ng-container>

					<span class="amount">
						<span class="number">
							{{commission.maxCommission | tcCurrency: commission.payOrGetPrecision}}
						</span>
						<span class="currency">
							{{commission.payOrGetCurrencyCode}}
						</span>
					</span>
				</span>
			</span>

		</div>

	</ng-container>

	<!--Point-->
	<div class="point" *ngIf="commission.point">
		<span class="point-title">
			<i class="icon-gift"></i>
			{{'REQUEST.COMMISSION.POINT' | translate}}
			
		</span>

		<span class="point-value">
			{{commission.point | tcCurrency: pointPrecision }}
			
		</span>
	</div>

	<!--Get Amount-->
	<div class="get-amount">
		<span class="title">
			<ng-container *ngIf="getAmountTitle">
				{{getAmountTitle | translate}}
			</ng-container>

			<ng-container *ngIf="!getAmountTitle">
				{{'REQUEST.COMMISSION.GET_AMOUNT' | translate}}
			</ng-container>
		</span>

		<span class="amount">
			<span class="number">
				{{ commission.payOrGetAmount | tcCurrency: commission.payOrGetPrecision }}
			</span>
			<span class="">
				{{ commission.payOrGetCurrencyCode }}
			</span>
		</span>
	</div>

</div>
